import React from "react";
import {NavLink} from "react-router-dom";
function HeaderPrimary() {
  return (
      <header className="layout__header">
          <div className="container">
              <div className="header__logo logo">
                  <NavLink className="logo__link" to="/">
                      <img className="logo__img logo__img_primary" src="./img/logo.png" alt="image description"/>
                      <img className="logo__img logo__img_secondary" src="./img/logo2.png" alt="image description"/>
                      <img className="logo__img logo__img_tertiary" src="./img/logo3.png" alt="image description"/>
                      <img className="logo__img logo__img_quarty" src="./img/logo4.png" alt="image description"/>
                  </NavLink>
              </div>
              <nav className="header__nav nav">
                  <ul className="nav__list">
                      <li className="nav__item"><NavLink activeClassName="active" className="nav__link" to="/single/cards">Карточки</NavLink></li>
                      <li className="nav__item"><NavLink activeClassName="active" className="nav__link" to="/single/puzzles">Загадки</NavLink></li>
                      <li className="nav__item"><NavLink activeClassName="active" className="nav__link" to="/single/test">Тест</NavLink></li>
                      <li className="nav__item"><NavLink activeClassName="active" className="nav__link" to="/download">Скачать</NavLink></li>
                  </ul>
              </nav>
          </div>
      </header>
  );
}
export default HeaderPrimary;
